import http from './http';
import axios from 'axios';

export type TermsType = 'aptive_index' | 'aria_chat';

export interface AITermsStatus {
    aiTermsAccepted: boolean;
    aiTermsAcceptedAt: string | null;
    currentVersion: string;
    userVersion: string | null;
    needsUpdate: boolean;
    termsType?: TermsType;
}

export interface AITermsResponse {
    success: boolean;
    message: string;
    data: AITermsStatus;
}

class AITermsService {
    /**
     * Check the current AI terms acceptance status for the user
     * @param termsType - 'aptive_index' for business/HR terms, 'aria_chat' for consumer terms
     */
    async checkStatus(termsType: TermsType = 'aptive_index'): Promise<AITermsStatus> {
        try {
            const response = await http.get<AITermsResponse>(`/admin/ai-terms/status?termsType=${termsType}`);
            return response.data.data;
        } catch (error) {
            // 401 is expected when logged out; avoid noisy console/error overlay spam
            if (axios.isAxiosError(error) && error.response?.status === 401) {
                throw error;
            }
            console.error('Error checking AI terms status:', error);
            throw error;
        }
    }

    /**
     * Accept the AI terms
     * @param termsType - 'aptive_index' for business/HR terms, 'aria_chat' for consumer terms
     */
    async acceptTerms(termsType: TermsType = 'aptive_index'): Promise<AITermsStatus> {
        try {
            const response = await http.post<AITermsResponse>('/admin/ai-terms/accept', { termsType });
            return response.data.data;
        } catch (error) {
            console.error('Error accepting AI terms:', error);
            throw error;
        }
    }
}

const aiTermsService = new AITermsService();
export default aiTermsService;
